<template>
  <el-row :gutter="10">
    <el-col :span="10">
      <page-metadata-table />
    </el-col>
    <el-col :span="14">
      <page-metadata-options-table />
    </el-col>
  </el-row>
</template>
<script>
import PageMetadataTable from './components/metadata-table'
import PageMetadataOptionsTable from './components/metadata-options-table'
export default {
  name: 'material-materialMetadata',
  components: {
    PageMetadataTable,
    PageMetadataOptionsTable,
  },
}
</script>
